import { h, Fragment } from 'preact';
import { getOrdinal } from 'src/common/utils';
import { MONTH_NAMES } from 'src/common/constants';

interface OrdinalDateProps {
    datetime?: number;
}

const OrdinalDate = ({ datetime }: OrdinalDateProps) => {
    const date = datetime ? new Date(datetime * 1000) : new Date(); // should be in milliseconds
    const day = date.getUTCDate();
    const month = MONTH_NAMES[date.getUTCMonth()];

    return (
        <>
            {month} {day}
            <sup>{getOrdinal(day)}</sup>
        </>
    );
};

export default OrdinalDate;
